/* eslint-disable @typescript-eslint/no-explicit-any */

import { BackgroundBlockView } from './background-block-view';
import { HowToArriveBlockView } from './how-to-arrive-block-view';
import { PartnershipBannerBlockView } from './partnership-banner-block-view';
import { PresentationSlideBlockView } from './presentation-slide-block-view';
import { PromotedBlockView } from './promoted-block-view';
import { SEOTextBlockView } from './seo-text-block-view';
import { TextImageBlockView } from './text-image-block-view';
import { TwoColumnsBlockView } from './two-columns-block-view';

import type { CMSBlockType } from '@/src/cms/domain/types/cms-block.types';
import type { ReactNode } from 'react';

export const cmsBlockViewMap = {
  'text-image-block': TextImageBlockView,
  'seo-text-block': SEOTextBlockView,
  'presentation-slide-block': PresentationSlideBlockView,
  'background-block': BackgroundBlockView,
  'promoted-block': PromotedBlockView,
  'two-columns-block': TwoColumnsBlockView,
  'how-to-arrive-block': HowToArriveBlockView,
  'partnership-banner-block': PartnershipBannerBlockView
} as const satisfies Record<CMSBlockType, (props: any) => ReactNode>;
